import axios from '@axios'

export default {
  findAll(pageConfig) {
    const page = pageConfig.page - 1
    const { size, sort, order } = pageConfig
    const queryUrl = `?page=${page}&size=${size}&sort=${sort},${order}`
    return axios.get(`/financeiro/ajuste_conta${queryUrl}`)
  },
  findById(id) {
    return axios.get(`/financeiro/ajuste_conta/${id}`)
  },
  insert(data) {
    return axios.post('/financeiro/ajuste_conta', data)
  },
  filtro(data, pageConfig) {
    const page = pageConfig.page - 1
    const { size, sort, order } = pageConfig
    const queryUrl = `?page=${page}&size=${size}&sort=${sort},${order}`
    return axios.post(`/financeiro/ajuste_conta/filtro${queryUrl}`, data)
  },
  delete(id) {
    return axios.delete(`/financeiro/ajuste_conta/${id}`)
  }
}
